/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateTimesheetSettingsData
 */
export interface UpdateTimesheetSettingsData {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTimesheetSettingsData
     */
    enableAutomaticRounding?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTimesheetSettingsData
     */
    roundUnscheduledTimesheets?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTimesheetSettingsData
     */
    roundUpTowardsStartTime?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTimesheetSettingsData
     */
    roundDownTowardsEndTime?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTimesheetSettingsData
     */
    roundUpBreaksToScheduledDuration?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateTimesheetSettingsData
     */
    startTimeRoundingMode?: UpdateTimesheetSettingsDataStartTimeRoundingModeEnum;
    /**
     * 
     * @type {number}
     * @memberof UpdateTimesheetSettingsData
     */
    startTimeRoundingPrecision?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateTimesheetSettingsData
     */
    endTimeRoundingMode?: UpdateTimesheetSettingsDataEndTimeRoundingModeEnum;
    /**
     * 
     * @type {number}
     * @memberof UpdateTimesheetSettingsData
     */
    endTimeRoundingPrecision?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateTimesheetSettingsData
     */
    breakRoundingMode?: UpdateTimesheetSettingsDataBreakRoundingModeEnum;
    /**
     * 
     * @type {number}
     * @memberof UpdateTimesheetSettingsData
     */
    breakRoundingPrecision?: number;
}

/**
* @export
* @enum {string}
*/
export enum UpdateTimesheetSettingsDataStartTimeRoundingModeEnum {
    NoRounding = 'No Rounding',
    RoundDown = 'Round Down',
    RoundNearest = 'Round Nearest',
    RoundUp = 'Round Up'
}
/**
* @export
* @enum {string}
*/
export enum UpdateTimesheetSettingsDataEndTimeRoundingModeEnum {
    NoRounding = 'No Rounding',
    RoundDown = 'Round Down',
    RoundNearest = 'Round Nearest',
    RoundUp = 'Round Up'
}
/**
* @export
* @enum {string}
*/
export enum UpdateTimesheetSettingsDataBreakRoundingModeEnum {
    NoRounding = 'No Rounding',
    RoundDown = 'Round Down',
    RoundNearest = 'Round Nearest',
    RoundUp = 'Round Up'
}


/**
 * Check if a given object implements the UpdateTimesheetSettingsData interface.
 */
export function instanceOfUpdateTimesheetSettingsData(value: object): value is UpdateTimesheetSettingsData {
    return true;
}

export function UpdateTimesheetSettingsDataFromJSON(json: any): UpdateTimesheetSettingsData {
    return UpdateTimesheetSettingsDataFromJSONTyped(json, false);
}

export function UpdateTimesheetSettingsDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateTimesheetSettingsData {
    if (json == null) {
        return json;
    }
    return {
        
        'enableAutomaticRounding': json['enableAutomaticRounding'] == null ? undefined : json['enableAutomaticRounding'],
        'roundUnscheduledTimesheets': json['roundUnscheduledTimesheets'] == null ? undefined : json['roundUnscheduledTimesheets'],
        'roundUpTowardsStartTime': json['roundUpTowardsStartTime'] == null ? undefined : json['roundUpTowardsStartTime'],
        'roundDownTowardsEndTime': json['roundDownTowardsEndTime'] == null ? undefined : json['roundDownTowardsEndTime'],
        'roundUpBreaksToScheduledDuration': json['roundUpBreaksToScheduledDuration'] == null ? undefined : json['roundUpBreaksToScheduledDuration'],
        'startTimeRoundingMode': json['startTimeRoundingMode'] == null ? undefined : json['startTimeRoundingMode'],
        'startTimeRoundingPrecision': json['startTimeRoundingPrecision'] == null ? undefined : json['startTimeRoundingPrecision'],
        'endTimeRoundingMode': json['endTimeRoundingMode'] == null ? undefined : json['endTimeRoundingMode'],
        'endTimeRoundingPrecision': json['endTimeRoundingPrecision'] == null ? undefined : json['endTimeRoundingPrecision'],
        'breakRoundingMode': json['breakRoundingMode'] == null ? undefined : json['breakRoundingMode'],
        'breakRoundingPrecision': json['breakRoundingPrecision'] == null ? undefined : json['breakRoundingPrecision'],
    };
}

  export function UpdateTimesheetSettingsDataToJSON(json: any): UpdateTimesheetSettingsData {
      return UpdateTimesheetSettingsDataToJSONTyped(json, false);
  }

  export function UpdateTimesheetSettingsDataToJSONTyped(value?: UpdateTimesheetSettingsData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'enableAutomaticRounding': value['enableAutomaticRounding'],
        'roundUnscheduledTimesheets': value['roundUnscheduledTimesheets'],
        'roundUpTowardsStartTime': value['roundUpTowardsStartTime'],
        'roundDownTowardsEndTime': value['roundDownTowardsEndTime'],
        'roundUpBreaksToScheduledDuration': value['roundUpBreaksToScheduledDuration'],
        'startTimeRoundingMode': value['startTimeRoundingMode'],
        'startTimeRoundingPrecision': value['startTimeRoundingPrecision'],
        'endTimeRoundingMode': value['endTimeRoundingMode'],
        'endTimeRoundingPrecision': value['endTimeRoundingPrecision'],
        'breakRoundingMode': value['breakRoundingMode'],
        'breakRoundingPrecision': value['breakRoundingPrecision'],
    };
}

